module.exports = __webpack_public_path__ + "img/avatar-4.23e3303a.png";